define('views/content/reports/reseller_stocks',['require','backbone','marionette','datatables','text!templates/content/reports/reseller_stocks.html'],function(require){

    var Backbone = require('backbone');
    require('marionette');
    require('datatables');

    var temp = require("text!templates/content/reports/reseller_stocks.html");

    return Backbone.Marionette.CompositeView.extend({
        // html template for the view
        template: _.template(temp),
        className: 'report-page',
        titleKey: 'reseller_stocks',

        initialize: function(options) {
            App.context.changePageTitle(App.polyglot.t(this.titleKey));
        },

        ui: function() {
            return {
                resellerStocksTable: '.reseller-stocks-list'
            };
        },

        onRender: function () {
            this.getReports();
        },

        getReports: function () {
            var _this = this;

            $.ajax({
                url: App.Config.apiBase + 'reports/reseller-stock-reports/',
                method: 'get',
                success: function (response) {
                    _this.showResellerStockReports(response.reseller_stock_report);
                }
            });
        },

        showResellerStockReports: function (reportData) {
            // Transform report data for datatables format
            var gridColumns = [
                { title: App.polyglot.t('reseller') },
                { title: App.polyglot.t('days_since_last_purchase'), className: 'text-right' }
            ];

            var totalRow = {};
            var products = reportData[0].products;

            products.forEach(function (product) {
                gridColumns.push({title: product.name, className: 'text-right'});
                totalRow[product.id] = 0;
            });

            var gridData = [];
            reportData.forEach(function (reportRow) {
                var rowData = [
                    '<a href="/reports/reseller-sales?reseller_id=' + reportRow.reseller.id + '">' + reportRow.reseller.name + '<a/>',
                    reportRow.last_purchase_days
                ];

                reportRow.products.forEach(function (product) {
                   rowData.push(product.count);

                   totalRow[product.id] += product.count;
                });

                gridData.push(rowData);
            });

            // Add total row
            var totalRowData = [
                App.polyglot.t('total'),
                ''
            ];

            products.forEach(function (product) {
               totalRowData.push(totalRow[product.id]);
            });
            gridData.push(totalRowData);

            if (!this.resellerStocksDataTable) {
                this.resellerStocksDataTable = this.ui.resellerStocksTable.DataTable({
                    paging: false,
                    ordering: false,
                    info: false,
                    searching: false,
                    data: gridData,
                    fixedHeader: true,
                    scrollY: App.utils.getContainerHeightWOffset(this.ui.resellerStocksTable),
                    columns: gridColumns,
                    buttons: [
                        'print'
                    ]
                });
            } else {
                this.resellerStocksDataTable.clear();
                this.resellerStocksDataTable.rows.add(gridData);
                this.resellerStocksDataTable.columns.adjust().draw();
            }
        }

    });
});
